import { useConfig } from '@exam-management/configuration';
import { QBankStructureStatus } from '@exam-management/graphql';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import {
  ItemSetList,
  QContentListFilterSection,
  QContentList,
  QContentNavigationTabs,
  QContentImportButton,
  AddNewQContentButton,
} from '@exam-management/qcontent-list';
import { Box, Divider, Flex, Grid, Paper, styled, Text } from '@shared/components';
import { WithPermission } from '@shared/permissions';

const StyledPaper = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  boxShadow: 'none',
}));

export default function QContentListPage() {
  const { qBankStructureInformation } = useQBankStructure();
  const configuration = useConfig();

  const { status } = qBankStructureInformation;
  const { singleImportTemplateUrl, itemSetImportTemplateUrl } = configuration.modules.qcontent;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        p: theme.spacing(6),
      })}
    >
      <Paper
        sx={(theme) => ({
          flexGrow: 1,
          borderRadius: theme.shape.rounded(2),
        })}
      >
        <Flex sx={{ flexDirection: 'column', width: '100%', height: '100%' }}>
          <Box sx={{ p: (theme) => theme.spacing(4, 6) }}>
            <Flex sx={{ justifyContent: 'space-between' }}>
              <Text variant='h3'>QContent List</Text>
              {status !== QBankStructureStatus.Archived ? (
                <WithPermission requiredPermission={APP_PERMISSIONS.QBANK.QUESTION.CREATE}>
                  <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
                    <QContentImportButton
                      singleImportTemplateUrl={singleImportTemplateUrl}
                      itemSetImportTemplateUrl={itemSetImportTemplateUrl}
                    >
                      Import
                    </QContentImportButton>
                    <AddNewQContentButton>Add Question</AddNewQContentButton>
                  </Flex>
                </WithPermission>
              ) : null}
            </Flex>
          </Box>
          <Divider />
          <Grid
            sx={(theme) => ({
              height: '100%',
              gap: theme.spacing(4),
              gridTemplateColumns: '360px minmax(0, 1fr)',
              p: theme.spacing(6),
              width: '100%',
            })}
          >
            <StyledPaper>
              <QContentListFilterSection />
            </StyledPaper>
            <StyledPaper>
              <Flex sx={{ flexDirection: 'column', height: 1 }}>
                <QContentNavigationTabs />
                <QContentList />
                <ItemSetList />
              </Flex>
            </StyledPaper>
          </Grid>
        </Flex>
      </Paper>
    </Flex>
  );
}
